module.exports = __webpack_public_path__ + "static/media/manage-content.dce0b0cc.svg";